import { Link } from "react-router-dom";
import { heroHighlights } from "@/mocks/manga";

export default function Hero() {
  return (
    <section className="relative min-h-[640px] w-full overflow-hidden pt-16 md:pt-[72px]">
      {/* 背景图 */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dreamy%20anime%20romance%20scene%20of%20a%20young%20couple%20standing%20under%20falling%20pink%20cherry%20blossom%20petals%20at%20warm%20sunset%2C%20soft%20blurred%20light%20bokeh%2C%20warm%20peach%20and%20rose%20gradient%20sky%2C%20romantic%20heartfelt%20atmosphere%2C%20wide%20cinematic%20composition%2C%20clean%20stylized%20illustration%20style&width=1600&height=900&seq=taotao-hero-2026-01&orientation=landscape"
          alt="桃桃漫画网 桃色恋爱剧情在线看 浪漫樱花动漫背景"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/55 via-foreground-950/35 to-background-50"></div>
      </div>

      <div className="relative z-10 mx-auto flex min-h-[560px] w-full max-w-[1400px] flex-col items-center justify-center px-4 py-14 text-center md:py-20">
        <span className="flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-xs font-medium tracking-wide text-background-50 backdrop-blur-sm">
          <i className="ri-heart-3-fill text-accent-400"></i>
          桃色剧情 · 暧昧桥段 · 心动瞬间 高能合集
        </span>
        <h1 className="mt-6 font-display text-4xl leading-tight text-background-50 md:text-6xl">
          桃桃漫画网
        </h1>
        <p className="mt-5 max-w-2xl text-base leading-relaxed text-background-100 md:text-lg">
          桃色恋爱剧情专区，精选脸红情节与恋爱拉扯高能片段。
          情感发展细腻、心动瞬间密集，喜欢看感情线慢慢升温的你，在这里总能找到对味的作品。
        </p>
        <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row">
          <Link
            to="/#hot"
            className="flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-[15px] font-medium text-background-50 shadow-lg shadow-primary-500/30 transition-colors hover:bg-primary-600"
          >
            <i className="ri-heart-pulse-fill"></i>
            去逛热门榜单
          </Link>
          <Link
            to="/#categories"
            className="flex items-center gap-2 whitespace-nowrap rounded-full border border-background-50/60 bg-background-50/10 px-7 py-3 text-[15px] font-medium text-background-50 backdrop-blur-sm transition-colors hover:bg-background-50/20"
          >
            <i className="ri-compass-3-line"></i>
            按栏目找作品
          </Link>
        </div>

        {/* 今日心动精选 */}
        <div className="mt-12 grid w-full grid-cols-1 gap-4 sm:grid-cols-3">
          {heroHighlights.map((item) => (
            <Link
              key={item.id}
              to={`/detail/${item.id}`}
              className="group flex items-center gap-3 rounded-2xl border border-background-50/20 bg-foreground-950/35 p-3 text-left backdrop-blur-md transition-colors hover:border-primary-300/50 hover:bg-foreground-950/50"
            >
              <img
                src={item.cover}
                alt={`${item.title} 桃桃漫画网心动精选`}
                className="h-20 w-14 shrink-0 rounded-lg object-cover"
              />
              <span className="min-w-0">
                <span className="flex items-center gap-2">
                  <span className="rounded-full bg-accent-500/90 px-2 py-0.5 text-[11px] font-medium text-background-50">
                    今日心动
                  </span>
                  <span className="text-[11px] text-background-200">{item.categoryName}</span>
                </span>
                <span className="mt-1 block truncate font-bold text-background-50 group-hover:text-primary-200">
                  {item.title}
                </span>
                <span className="mt-0.5 block truncate text-xs text-background-200/90">
                  {item.heroLine}
                </span>
                <span className="mt-1 block truncate text-[11px] text-accent-300">
                  {item.latestChapter}
                </span>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}